import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import Landing from '@/views/Landing'
import Login from '@/views/Login'
import Signup from '@/views/Signup'
import AlterPassword from '@/views/AlterPassword'
import AdminCompany from '@/views/AdminCompany'
import AdminCepe from '@/views/AdminCepe'
import UserManagement from '@/views/UserManagement'
import CompanyManagement from '@/views/CompanyManagement'
import ProjectManagement from '@/views/ProjectManagement'
import EditUser from '@/views/EditUser'
import EditParameters from '@/views/EditParameters'
import EditCompany from '@/views/EditCompany'
import SignupCompany from '@/views/SignupCompany'
import AddProject from '@/views/AddProject'
import ProjectDashboard from '@/views/ProjectDashboard'
import PixTest from '@/views/PixTest'
import ResetPassword from '@/views/ResetPassword'
import EditProject from '@/views/EditProject'

Vue.use(Router);

const routes = [
    {
        name: 'home',
        path: '/home',
        component: Home,
        meta: {
            name: 'Página Inicial',
            breadcrumb: []
        }
    },
    {
        name: 'login',
        path: '/login',
        component: Login
    },
    {
        name: 'root',
        path: '/',
        component: Landing
    },
    {
        name: 'signup',
        path: '/signup',
        component: Signup,
        meta: {
            name: 'Cadastrar Usuários',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'alterPassword',
        path: '/alterPswd',
        component: AlterPassword,
        meta: {
            name: 'Alterar Senha',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'adminCompany',
        path: '/adminCompany',
        component: AdminCompany,
        meta: {
            name: 'Administração',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'adminCepe',
        path: '/adminCepe',
        component: AdminCepe,
        meta: {
            name: 'Administração',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'userManagement',
        path: '/userManagement',
        component: UserManagement,
        meta: {
            name: 'Gestão de Usuários',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'companyManagement',
        path: '/companyManagement',
        component: CompanyManagement,
        meta: {
            name: 'Gestão de Empresas',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'editUser',
        path: '/editUser/:id',
        component: EditUser,
        meta: {
            name: 'Editar Usuário',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'},
                { name: 'Gestão de Usuários', link:'userManagement' },
            ]
        }
    },
    {
        name: 'editParameters',
        path: '/editParameter/:companyId',
        component: EditParameters,
        meta: {
            name: 'Configurar Parâmetros',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'},
                { name: 'Gestão de Empresas', link:'companyManagement' },
            ]
        }
    },
    {
        name: 'editCompany',
        path: '/editCompany/:companyId',
        component: EditCompany,
        meta: {
            name: 'Editar Empresa',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'},
                { name: 'Gestão de Empresas', link:'companyManagement' },
            ]
        }
    },
    {
        name: 'signupCompany',
        path: '/signupCompany',
        component: SignupCompany,
        meta: {
            name: 'Cadastrar Empresa',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'addProject',
        path: '/addProject',
        component: AddProject,
        meta: {
            name: 'Cadastrar Projeto',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'projectDashboard',
        path: '/projectDashboard/:projectId',
        component: ProjectDashboard,
        meta: {
            name: 'Dashboard',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'},
                { name: 'Gestão de Projetos', link:'projectManagement' }
            ]
        }
    },
    {
        name: 'projectManagement',
        path: '/projectManagement',
        component: ProjectManagement,
        meta: {
            name: 'Gestão de Projetos',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'pixTest',
        path: '/pixtest',
        component: PixTest,
        meta: {
            name: 'Cobrança PIX',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'}
            ]
        }
    },
    {
        name: 'resetPassword',
        path: '/resetPassword/:token',
        component: ResetPassword,
        meta: {
            name: 'Redefinir senha de Usuário'
        }
    },
    {
        name: 'editProject',
        path: '/editProject/:id',
        component: EditProject,
        meta: {
            name: 'Editar Projeto',
            breadcrumb: [
                { name: 'Página Inicial', link:'home'},
                { name: 'Gestão de Projetos', link:'projectManagement' }
            ]
        }
    }
]

const router = new Router({  mode: 'history', routes })

export default router